import api from './api';
import { STORAGE_KEYS } from '../utils/constants';

export const authService = {
  // Login admin user
  login: async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      
      // Validate response is JSON
      if (!response.data || typeof response.data !== 'object') {
        throw new Error('Invalid response format from server');
      }
      
      // Handle response structure
      const responseData = response.data?.data || response.data;
      const { token, user } = responseData;
      
      if (!token || !user) {
        throw new Error('Invalid response from server: missing token or user data');
      }
      
      // Store token and user info
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
      
      return { token, user };
    } catch (error) {
      console.error('Login error:', error);
      
      // Extract error message from response if available
      if (error.response?.data) {
        const responseData = error.response.data;
        // Handle different response structures
        if (responseData.message) {
          error.message = responseData.message;
        } else if (responseData.error) {
          error.message = responseData.error;
        } else if (responseData.data?.message) {
          error.message = responseData.data.message;
        }
      }
      
      // Provide more helpful error messages for connection issues
      if (error.message && (error.message.includes('non-JSON') || error.message.includes('error page'))) {
        throw new Error('Server configuration error. Please check if the backend API is running and accessible.');
      }
      
      // Preserve the error with the extracted message
      throw error;
    }
  },

  // Logout admin user
  logout: () => {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
  },

  // Get current user from storage
  getCurrentUser: () => {
    const userStr = localStorage.getItem(STORAGE_KEYS.USER);
    return userStr ? JSON.parse(userStr) : null;
  },

  // Get token from storage
  getToken: () => {
    return localStorage.getItem(STORAGE_KEYS.TOKEN);
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem(STORAGE_KEYS.TOKEN);
  },

  // Get current user info from API
  getMe: async () => {
    try {
      const response = await api.get('/auth/me');
      
      // Validate response is JSON
      if (!response.data || typeof response.data !== 'object') {
        throw new Error('Invalid response format from server');
      }
      
      return response.data.data || response.data;
    } catch (error) {
      console.error('GetMe error:', error);
      
      // Provide more helpful error messages
      if (error.message.includes('non-JSON') || error.message.includes('error page')) {
        throw new Error('Server configuration error. Please check if the backend API is running and accessible.');
      }
      
      throw error;
    }
  },
};
